export const SchedulingOptions = [
    {
        label: 'Automated Message Scheduling',
        value: 'false',
    },
    {
        label: 'Controlled Message Scheduling',
        value: 'true',
    },
];
